import api from '@/api';

export default {
    getUserByPersonCode(personCode: string): Promise<account.User> {
      return api.get({
          url: `/api/hr/department/person`,
          params: {
              personCode,
          }
      })
    },

     /**
     * 양식 및 시스템 옵션을 조회합니다.
     * @param typeId 양식/시스템 구분값
     * @returns 
     */
    getApplicationOptionList(payload: workflow.RequestWorkflowOption): Promise<workflow.CM_ApplicationOption> {
        return api.post<workflow.CM_ApplicationOption>({
            url: '/workflow/application/api/getapplicationoption',
            data: payload
        })
    },

    // 문서함 페이지
    getDocumentPages(): Promise<workflow.TC_DOCUMENT_PAGES> {
        return api.post<workflow.TC_DOCUMENT_PAGES>({
            url: `/workflow/Common/api/getDocumentPages`
        });
    },
}